import { css } from '@lastbrand/web-ui-styled-system/css'

import { optionBoxRecipe } from './option-selector-shared.styles'

/**
 * DS twin styling for the color group. `SelectColorGroup` owns the swatch chrome;
 * the only externally-rendered bits are the per-swatch red sale dot (kept on its
 * own `areAllColorVariantsOnSale` predicate) and its column wrapper — both shared
 * with the image option.
 */
export { optionColumnClass as colorOptionWrapperClass, redDotClass } from './option-selector-shared.styles'

/**
 * A text-only color value (displayType `Text`, no hex + no image — e.g. "Wine Tasting")
 * rendered as a radio pill that lives INSIDE the color group's `SelectColorGroup` Root, so
 * the mixed group stays one single-choice radiogroup. Shares `optionBoxRecipe`'s border with
 * the other DS option boxes and mirrors the DS text option shape (body-14, space-10/space-16,
 * square). Selection is Radix-driven, so the selected black border keys off the button's own
 * `data-state="checked"` — there is no preceding `<input>` sibling for the recipe's `input:checked + &`.
 *
 * The focus ring copies web-ui's own `SelectColorGroupItem` verbatim (2px solid black, `0.25rem`
 * offset). `rem` is deliberate here despite the DS px convention: the pill renders inside the same
 * `SelectColorGroup` Root as those swatches, and `rem` is document-root-relative — so the pill's
 * offset resolves to the exact same length as the neighbouring rem-locked swatches in any
 * root-font-size context. A px/token here would drift from the swatch under the capped legacy root.
 */
export const textPillClass = css(optionBoxRecipe.raw(), {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
  textStyle: 'body-14',
  minWidth: '50px',
  paddingBlock: 'space-10',
  paddingInline: 'space-16',
  borderRadius: 'radius-none',
  backgroundColor: 'white',
  color: 'black',
  cursor: 'pointer',
  whiteSpace: 'nowrap',
  transition: 'border-color 150ms ease-in-out',
  '&[data-state="checked"]': { borderColor: 'black' },
  _focusVisible: { outlineWidth: '2px', outlineStyle: 'solid', outlineColor: 'black', outlineOffset: '0.25rem' },
})
